import type { Step } from "../types";
import { getNanoId, nanoIdWithProcessId } from "../utils";

// Replaced from Date.now() to nano ids as in bulk duplication the ids will be same and will cause issues.
export const createStep = ({
  processId,
  props
}: {
  processId: string;
  props?: Partial<Step>;
}) => {
  const newStep: Step = {
    id: nanoIdWithProcessId(processId),
    name: "",
    fields: [],
    deadline: 0,
    tag: `step-${getNanoId()}`,
    dependentSteps: [],

    isFilterable: true,
    __createdAt: Date.now(),
    __modifiedAt: Date.now(),
    __tagReadonly: false,
    ...props
  };
  return newStep;
};
